<template>
  <div class="ak-cards__item">
    <slot />
  </div>
</template>

<script>
import { defineComponent, inject, ref } from 'vue'

export default defineComponent({
  /**
   * @type {String}
   * @description This is the name of the component this will also
   * be the tag name of the component to use in templates
   * @example
   * <ak-cards-item>
   *   <ak-card>
   *     <ak-card-body :type="'comfy">
   *       <p>Lorem ipsum dolor.</p>
   *     </ak-card-body>
   *   </ak-card>
   * </ak-cards-item>
   */
  name: 'AkCardsItem',

  provide() {
    return {
      akCardsItem: this,
    }
  },

  /**
   * @description Sets up the component and returns an object containing all of the
   * attributes for the component to use.
   */
  setup() {
    const parent = inject('akCards')
    const isCardItem = ref(true)

    const select = (value) => {
      /* istanbul ignore else */
      if (typeof parent.select === 'function') {
        parent.select(value)
      }
    }

    return {
      select,
      isCardItem,
    }
  },
})
</script>

<style lang="scss">
@import '../../scss/_settings.scss';
.ak-cards__item {
  display: flex;
}
</style>
